import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    margin: '8px 0'
  },
  main: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr' },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  header: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  headerText: { fontWeight: 600, color: theme.palette.text.primary },
  headerTextExceptOne: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    textAlign: 'center'
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 6
  },
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    background: theme.palette.grey[300],
    padding: '6px 8px',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px'
  },
  left: {
    display: 'flex',
    justifyContent: 'flex-start',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
    alignItems: 'center',
    paddingLeft: 8
  },
  middle: {
    display: 'flex',
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    alignItems: 'center'
  },
  right: {
    display: 'flex',
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    alignItems: 'center'
  },
  text: { fontWeight: 500 },
  formcontrol: { margin: '0px', padding: 0 }
}))
